<template>
  <div>
      <v-data-table
        :headers="headers"
        :items="delinquents"
        :page.sync="page"
        :items-per-page="delinquentsPerPage"
        :server-items-length="totalDelinquents"
        hide-default-footer
        @page-count="pageCount = $event"
        sort-by="name"
        class="elevation-1 ml-4"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
          <v-col
            cols="12"
            sm="3"
          >
          <v-select
            :items="organizations"
            item-text="name"
            item-value="id"
            v-model="organizationId"
            dense
            outlined
            color="grey"
            hint="Filter by Organization"
            persistent-hint
            class="mt-8 mx-4"
            solo
          />
          </v-col>
          <v-col
            cols="12"
            sm="3"
          >
          <v-text-field
            v-model="delinquentFirstName"
            dense
            outlined
            color="grey"
            hint="Filter by Name"
            persistent-hint
            class="mt-8 mx-4"
            solo
          />
          </v-col>
          <v-btn
            class="mt-2"
            elevation="1"
            fab
            small
            @click="loadAllDelinquents"
          >
            <v-icon>mdi-magnify</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn rounded disabled right>{{currentCenter.name}}</v-btn>
          </v-toolbar>
        </template>
        <template v-slot:item.names="{ item }">
          <p @click="loadProfile(item)" class=" btn blue--text">{{ item.names }}</p>
        </template>
      </v-data-table>
        <div class="pt-2 px-12">
        <v-row>
        <v-col cols="12" sm="2">
        <v-select
          :items="selectDelinquentsPerPage"
          v-model="delinquentsPerPage"
          label="Delinquents per page"
          dense
        ></v-select>
        </v-col>
        <v-col cols="12" sm="8">
        <v-pagination
          v-model="page"
          :length="pageCount"
          circle
          total-visible="7"
          color="blue"
        ></v-pagination>
        </v-col>
        <v-col cols="12" sm="2">
          {{totalDelinquents}} Records
        </v-col>
        </v-row>
      </div>
  <v-snackbar
      v-model="snackbar"
      top
      :color="color"
      :timeout="timeout"
    >
      {{ text }}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="blue"
          icon
          v-bind="attrs"
          @click="setSnackbar(false)"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from 'vuex'
export default {
  data () {
    return {
      dialog: false,
      privileges: null,
      showCreate: false,
      addDialog: false,
      names: null,
      selectDate: true,
      releaseDialog: false,
      disableRequest: false,
      headers: [
        {
          text: 'ID',
          align: 'start',
          sortable: false,
          value: 'no'
        },
        { text: 'Names', value: 'names' },
        { text: 'Age', value: 'delinquent.age' },
        { text: 'Graduation Date', value: 'graduationDate' },
        { text: 'From Center Name', value: 'center' },
        { text: 'Guardian Name', value: 'delinquent.guardian' },
        { text: 'Guardian Phone', value: 'delinquent.guardianPhone' },
        { text: 'Organization', value: 'occupations[0].organizationName' },
        { text: 'Occupation', value: 'occupations[0].name' }
      ],
      delinquents: [],
      selectDelinquentsPerPage: [2, 5, 10, 15, 20, 25, 30],
      page: 1,
      pageCount: 0,
      delinquentsPerPage: 20,
      totalDelinquents: 0,
      organizations: [],
      emptyDistrict: { id: null, name: '' },
      organization: null,
      errors: null,
      panel: 3,
      delinquentFirstName: null,
      delinquentLastName: null,
      placeOfBirthId: null,
      residenceId: null,
      recordDates: null,
      arrivalDates: null,
      exitDates: null,
      released: null,
      states: null,
      eligibilityStates: null,
      intakeId: null,
      intakeSet: null,
      decisionIds: null,
      physicallyScreened: null,
      screeningApprovalStatuses: null,
      onGraduationList: null,
      graduationId: null,
      expand: false,
      graduationApprovalStatuses: null,
      postRehabDestinationId: null,
      hasOccupation: null,
      organizationId: null,
      sort: 'apprehension.delinquent.firstName,desc',
      releaseDate: new Date().toISOString(),
      releaseDateMenu: false
    }
  },

  computed: {
    ...mapState('store', ['snackbar', 'color', 'text', 'timeout', 'currentUser', 'currentCenter', 'search', 'storeProvinces', 'storeProvincesError', 'deviantActs', 'identificationDocuments', 'apprehensionItems'])
  },

  watch: {
    page: {
      handler () {
        this.loadAllDelinquents()
      }
    },
    delinquentsPerPage: {
      handler () {
        this.page = 1
        this.loadAllDelinquents()
      }
    }
  },
  mounted () {
    this.loadAllDelinquents()
    this.privileges = this.currentUser.privileges
    this.checkPrivileges()
  },
  created () {
    this.loadOrganizations()
  },
  destroyed () {
    this.setSnackbar(false)
  },

  methods: {
    ...mapActions('store', ['loadStoreProvinces']),
    ...mapMutations('store', {
      setSnackbar: 'SET_SNACKBAR',
      setColor: 'SET_COLOR',
      setText: 'SET_TEXT',
      setDelinquentItem: 'SET_DELINQUENT_ITEM'
    }),
    loadAllDelinquents () {
      const pageNumber = this.page - 1
      this.delinquentLastName = this.delinquentFirstName
      this.expand = 'occupations'
      this.released = true
      this.states = 'GRADUATED'
      this.organizationId = this.organization
      this.$delinquentService.fetchAllTransfersSpecification(this.delinquentFirstName, this.delinquentLastName, this.placeOfBirthId, this.residenceId, this.recordDates, this.arrivalDates, this.exitDates, this.released, this.states, this.eligibilityStates, this.intakeId, this.intakeSet, this.decisionIds, this.physicallyScreened, this.screeningApprovalStatuses, this.onGraduationList, this.graduationId, this.expand, this.graduationApprovalStatuses, this.postRehabDestinationId, this.hasOccupation, this.organizationId, pageNumber, this.delinquentsPerPage, this.sort)
        .then(response => {
          if (!response.status) {
            this.delinquents = response.content
            this.totalDelinquents = response.totalElements
            let index = 1
            this.delinquents.forEach(element => {
              element.no = index
              element.names = element.delinquent.firstName + ' ' + element.delinquent.lastName
              element.delinquent.dateOfBirth = this.$moment(element.delinquent.dateOfBirth).format('YYYY')
              element.delinquent.age = parseInt(this.$moment(new Date().toISOString().substr(0, 10)).format('YYYY')) - parseInt(this.$moment(element.delinquent.dateOfBirth).format('YYYY'))
              index = index + 1
            })
          } else {
            // this.$authenticationService.checkAuthentication(response.status, this.$router, this.$store)
            this.setSnackbar(true)
            this.setColor('red')
            this.setText('Read Delinquents: ' + response.message)
          }
        })
    },
    loadOrganizations () {
      this.$delinquentService.fetchOrganizations(null, null, null, null, null)
        .then(response => {
          if (!response.status) {
            this.organizations = response.content
          } else {
            this.setSnackbar(true)
            this.setColor('red')
            this.setText(response.message)
          }
        })
    },
    loadProfile (item) {
      this.setDelinquentItem(item)
      this.$router.push('/delinquent-profile')
    },
    checkPrivileges () {
      this.privileges.includes('CREATE_DELINQUENTS') || this.privileges.includes('ALL_AUTHORITIES') ? this.showCreate = true : this.showCreate = false
      this.privileges.includes('UPDATE_DELINQUENTS') || this.privileges.includes('ALL_AUTHORITIES') ? this.showEdit = true : this.showEdit = false
      this.privileges.includes('DELETE_DELINQUENTS') || this.privileges.includes('ALL_AUTHORITIES') ? this.showDelete = true : this.showDelete = false
    }
  }
}
</script>
<style scoped>
.btn {
  cursor: pointer;
}
</style>
